const deepDiveContentCH = {
  family_env: {
    title: '家庭中的數碼健康環境',
    importance: [
      '家庭的整體數碼環境為孩子如何感知並與科技互動定下基調。孩子會透過觀察父母與照顧者的行為、態度與價值觀來學習；當大人展現健康的數碼習慣（如設定螢幕時間限制、目的性使用裝置、在線上互動中表現尊重與同理），孩子更可能採納類似行為。具支持性的家庭環境包含清晰的規範、開放的溝通與共享的數碼活動。一起討論線上內容、共同研究主題或進行創作，能培養孩子的批判思維、負責任的分享與網路安全素養。當父母投入且平易近人，孩子更願意主動分享並尋求指導，有助於及早辨識與處理風險。重視學習與好奇、而非被動消費的家庭，能引導孩子查證來源、評估資訊並成為有能力、合乎道德的科技使用者。'
    ]
  },

  family_ai_comms: {
    title: '家庭在數碼健康與人工智慧方面的溝通',
    importance: [
      '父母與孩子之間穩固的溝通與信任，是支持孩子數碼健康的關鍵。開放的對話讓孩子更自在地分享其線上經驗，不論是正向機會或是網路霸凌、不當內容、隱私疑慮等挑戰。當你以不帶評判的方式傾聽並引導，孩子在遇到問題時更願意尋求協助，既能提升安全也能培養數碼韌性。信任是基礎：當孩子相信你會支持而非苛責，他們會更願意在不確定時主動溝通。這樣的氛圍也讓父母更容易發現理解落差與潛在風險，於適當時機介入或教導，引導孩子以負責且安全的方式使用科技與 AI。'
    ]
  },

  resourcefulness: {
    title: '父母的應變能力與自我效能感',
    importance: [
      '你的自信、自我效能感與應變能力，是協助孩子健康使用科技的關鍵。當你對自己理解與駕馭數碼環境有信心時，更可能主動參與孩子的數碼生活、提供知識性支持並設定合宜界線。自我效能感高的父母，傾向採取更積極與正向的中介方式（如共同使用與指導性引導），而不僅是施加限制。此作法能促進孩子的自主性與自律，同時保障其數碼權利與安全的線上體驗。這類態度與行為能改善親子在科技使用上的關係，降低過度螢幕時間或成癮性使用等問題；在資源或技能落差情境下，更能善用可得資源，縮短數碼鴻溝並最大化孩子的學習與福祉。'
    ]
  },

  school_parent_comm: {
    title: '學校與家長溝通',
    importance: [
      '孩子的數碼健康仰賴穩固的「學校—家長—孩子三角」。當學校主動溝通數碼政策、資源與課程目標，家長更能在家中強化正向的數碼習慣；同時家長回饋也讓學校了解學生在家庭端的需求與落差。一致且互信的雙向溝通，能讓孩子獲得連貫的期望與指引。即便你未必熟悉最新趨勢或風險，學校提供的定期更新能彌補知識缺口，促成與孩子的有意義對話。家校合作可及早辨識數碼困擾（如過度螢幕、社群焦慮或風險性行為）並建設性介入，形塑共同責任的支持系統。學校可提供講座與資源，家長則分享家庭端觀察，彼此協作以建立健康的數碼環境。'
    ]
  }
};

export default deepDiveContentCH;
